"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDatadogContext = exports.useDatadogLogs = void 0;
const browser_logs_1 = require("@datadog/browser-logs");
/**
 * @public
 * Inicializa o monitoramento da aplicação.
 */
function useDatadogLogs(config) {
    browser_logs_1.datadogLogs.init(config);
}
exports.useDatadogLogs = useDatadogLogs;
/**
 * @public
 * Define um contexto para os logs.
 *
 * Esse contexto será utilizado em todos os próximos logs disparados até que outro contexto seja definido.
 */
function setDatadogContext(newContext) {
    browser_logs_1.datadogLogs.setLoggerGlobalContext({ context: newContext });
}
exports.setDatadogContext = setDatadogContext;
//# sourceMappingURL=datadog.js.map